export default __webpack_public_path__ + "static/media/dornbracht-armatura.f7de6be3.jpeg";